module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0098.png.c868560d.jpg";